import { UploadFileFiled } from '@/features/analytics/invite-links/ui/Marking/components/UploadFileFiled'
import { DocumentRecord, ORDMarkingFormData } from '@synapex/prisma/client'
import { WorkspaceWithLinkDescriptor } from '@synapex/shared2/entities'
import { ContractUnion } from '@synapex/shared2/gateway-rest-api'
import React, { useEffect, useMemo, useState } from 'react'

type FinalContractCardProps = {
    markingFormData: ORDMarkingFormData
    onDeleteContract: (
        type: 'draft' | 'final',
        contract: DocumentRecord
    ) => void
    onFileChange: (file: File) => void
    disabled?: boolean
    error?: boolean
    isLoading?: boolean
    className?: string
    contracts?: ContractUnion[]
} & WorkspaceWithLinkDescriptor

export const FinalContractCard: React.FC<FinalContractCardProps> = ({
    markingFormData,
    onDeleteContract,
    onFileChange,
    disabled = false,
    error = false,
    isLoading,
    className,
    contracts,
}) => {
    const documentRecords = contracts?.filter(
        (contract) => contract.type === 'default'
    )

    const [selectedItem, setSelectedItem] = useState<null | DocumentRecord>(
        null
    )

    const finalContracts = useMemo(() => {
        return documentRecords?.filter(
            (contract) => contract.status === 'final'
        )
    }, [documentRecords])

    const handleDelete = (contract: DocumentRecord) => {
        onDeleteContract('final', contract)
    }

    useEffect(() => {
        if (markingFormData.final_contract_id && finalContracts?.length) {
            setSelectedItem(
                finalContracts.find(
                    (contract) =>
                        contract.documentRecordId ===
                        markingFormData.final_contract_id
                )!
            )
        } else {
            setSelectedItem(null)
        }
    }, [contracts, finalContracts, markingFormData.final_contract_id])

    return (
        <UploadFileFiled
            onDeleteItem={handleDelete}
            onFileChange={onFileChange}
            disabled={disabled || !markingFormData.draft_contract_id}
            error={error}
            placeholder="Загрузить подписанный договор"
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            isLoading={isLoading}
            className={className}
        />
    )
}
